import { useMutation, useQueryClient } from '@tanstack/react-query';

import { schedulerApi } from '../api';

type WorkoutPreferenceUpdate = Record<string, unknown> & {
  note?: string;
  disableAutoSchedule?: boolean;
};

interface UseUpdateWorkoutPrefParams {
  preferenceId: string;
  preferences: Partial<WorkoutPreferenceUpdate>;
}

export const useUpdateWorkoutPref = () => {
  const queryClient = useQueryClient();

  const updateWorkoutPrefMutation = useMutation({
    mutationFn: ({ preferenceId, preferences }: UseUpdateWorkoutPrefParams) => {
      if (!preferenceId) {
        return;
      }
      return schedulerApi.updateWorkoutPreference(preferenceId, preferences).then((data) => data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lifestack.preference'] });
    },
  });

  return {
    updateWorkoutPref: updateWorkoutPrefMutation.mutateAsync,
    ...updateWorkoutPrefMutation,
  };
};
